import request from "@/utils/request";

export default function agencyGetInfo() {
    return request({
        url: `/agency/agencyGetInfo`,
        method: 'get',
    })
}
